import { Input, Text, Textarea } from "@chakra-ui/react";
import * as React from "react";
import { useFormContext } from "react-hook-form";

import { Field } from "../field";
import { StepContent } from "./step-content";
import { OptimizationFormData } from "./types";

export function NameStep() {
  const {
    register,
    formState: { errors },
  } = useFormContext<OptimizationFormData>();
  return (
    <StepContent title="Name & Description">
      <Field
        label="Name"
        invalid={!!errors.name}
        errorText={errors.name?.message}
      >
        <Input placeholder="Name your conversion event" {...register("name")} />
      </Field>
      <Field
        label="Description"
        invalid={!!errors.description}
        errorText={errors.description?.message}
        optionalText={
          <Text color="fg.muted" fontSize="xs">
            (optional)
          </Text>
        }
      >
        <Textarea
          placeholder="Describe what this conversion event does"
          {...register("description")}
        />
      </Field>
    </StepContent>
  );
}
